import React from 'react';
import { render } from 'react-dom';
import Immutable from 'seamless-immutable';
import 'console-shim';
import root from 'window-or-global';
import EpicGamesFooter from './EpicGamesFooter';
import addObserverCallback from './utils/epicGamesFooterObserver';

//this file is the entry point for webpack.config.js

const renderFooter = () => {
    let config = {};
    if (root._epicGamesFooterObserver && root._epicGamesFooterObserver.subject) {
        config = root._epicGamesFooterObserver.subject;
    }

    const epicPropertyName = config.epicPropertyName;
    const epicPropertyClasses = config.epicPropertyClasses;
    const links = Immutable(config.links);
    const messages = Immutable(config.messages);
    const logos = Immutable(config.logos);
    const socialLinks = Immutable(config.socialLinks);
    const legalTags = Immutable(config.legalTags);
    const copyrights = Immutable(config.copyrights);
    const upOnClick = config.upOnClick;
    const callToAction = Immutable(config.callToAction);
    const moreLegalLinks = Immutable(config.moreLegalLinks);
    const newLineCopyrights = config.newLineCopyrights;
    const isLoggedIn = config.isLoggedIn;
    const email = config.email;
    const newsLetterConfigs = config.newsLetterConfigs || {};
    const enableNewsLetter = (config.enableNewsLetter && newsLetterConfigs.enableNewsLetterCMS) || false;
    const i18n = Immutable(config.i18n);
    const hideDefaultTermsPolicy = config.hideDefaultTermsPolicy;

    render(
        <EpicGamesFooter
            epicPropertyName={epicPropertyName}
            epicPropertyClasses={epicPropertyClasses}
            links={links}
            socialLinks={socialLinks}
            moreLegalLinks={moreLegalLinks}
            legalTags={legalTags}
            copyrights={copyrights}
            messages={messages}
            logos={logos}
            upOnClick={upOnClick}
            callToAction={callToAction}
            newLineCopyrights={newLineCopyrights}
            isLoggedIn={isLoggedIn}
            email={email}
            enableNewsLetter={enableNewsLetter}
            newsLetterConfigs={newsLetterConfigs}
            i18n={i18n}
            hideDefaultTermsPolicy={hideDefaultTermsPolicy} />,

        document.getElementById('epicGamesFooter')
    );
};

addObserverCallback(renderFooter);
renderFooter();



// WEBPACK FOOTER //
// ./app/scripts/index.js